<template>
  <v-container fluid>
    <v-layout
      row
      wrap
    >
      <v-flex xs12>
        <data-table
          :resource="resources['user']"
          loading="loading"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import DataTable from "@/components/DataTable";
import { pickBy } from "lodash";

export default {
  data() {
    return {
      tab: null
    };
  },

  computed: {
    resources() {
      return this.$store.state.resources;
    },
    firebaseUsers() {
      return this.$store.state.entities.firebaseUsers;
    },
    loading() {
      return Object.keys(this.firebaseUsers).length;
    }
  },

  mounted() {
    this.$store.dispatch("API_GET", {
      url: '/users/firebase',
      entityType: 'firebaseUsers',
      schema: 'firebaseUserListSchema'
    });
  },

  components: {
    DataTable
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/systemSetup/Users.vue